import {
  boldFont,
  getRelativeFontSize,
  pureWhiteColor,
  theme,
} from "../../../../utils/styles";

const preferenceStyles = {
  headerText: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
    color: pureWhiteColor,
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(5),
    },
  },
} as const;

export default preferenceStyles;
